import React from 'react';
export default class Logo extends React.Component {
	render() {
        return (
            <a href="https://www.sensationax.com" title="Sensation Ax" className="logo float-left">
                <img src="/img/logo.png" alt="Sensation Ax" style={{height: 85}}/>
            </a>
        )
	}
}
